import ActionType from './action-type'
import * as Actions from './actions'
import {TimeRange} from '../../../values/TimeRange'
import {type LocationTagScore} from '../../../values/location-tag-score'

export function requestLocationTagThreatScore(
    timeRange: TimeRange,
): Actions.RequestLocationTagThreatScore {
    return {
        type: ActionType.REQUEST_LOCATION_TAG_THREAT_SCORE,
        payload: timeRange,
    }
}

/**
 * CDS-6008. Clears the loading flag for one range without touching its trend,
 * so a failed fetch stops the graph spinning and leaves whatever was last
 * received on screen.
 */
export function locationTagThreatScoreRequestFailed(
    timeRange: TimeRange,
): Actions.LocationTagThreatScoreRequestFailed {
    return {
        type: ActionType.LOCATION_TAG_THREAT_SCORE_REQUEST_FAILED,
        payload: timeRange,
    }
}

export function receiveLocationTagThreatScore(
    timeRange: TimeRange,
    scores: LocationTagScore[],
): Actions.ReceiveLocationTagThreatScore {
    return {
        type: ActionType.RECEIVE_LOCATION_TAG_THREAT_SCORE,
        payload: {
            timeRange: timeRange,
            scores: scores,
        },
    }
}
